<template>
  <div v-if="globalDiscountText && isGlobalDiscountLabelShowed" class="global-discount-label">
    <span>{{ globalDiscountText }}</span><span class="close-discount-label" v-on:click="closeLabel">&#10005;</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GlobalDiscountLabel',
  computed: {
    ...mapState([
      'globalDiscountText',
      'isGlobalDiscountLabelShowed'
    ])
  },
  methods: {
    closeLabel: function () {
      this.$store.commit('setStateValues', {
        isGlobalDiscountLabelShowed: false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.global-discount-label{
  background-color: #E90855;
  text-align: center;
  padding: 13px 25px;
  color: white;
  font-weight: 700;
  position: relative;
}
.close-discount-label{
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
